import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { ROUTES } from 'routes';
import { useApp } from 'providers';

export const useLogout = (): null => {
  const { pathname } = useLocation();
  const { logout } = useApp();

  useEffect(() => {
    if (matchPath(pathname, { path: ROUTES.logout, exact: true })) {
      logout();
    }
  }, [pathname, logout]);

  return null;
};
